<template>
  <div class="row">
    <div class="col-12 card">
      <h4>Договоры</h4>
      <!-- Показываем выбранные даты -->
      <br v-if="startDate && endDate" />
      <small v-if="startDate && endDate">
        c {{ format_date(startDate, 'date') }}
        по {{ format_date(endDate, 'date') }}
      </small>

      <div class="row justify-content-space-between">
        <div class="col-12">
          <!-- Фильтры -->
          <div class="row top-24">
            <div class="col-md-3">
              <div class="text-field">
                <label class="text-field__label">Дата начала</label>
                <div class="text-field__icon">
                  <input
                    class="text-field__input"
                    type="date"
                    v-model="startDate"
                    @change="updateDatesFromInputs"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="text-field">
                <label class="text-field__label">Дата окончания</label>
                <div class="text-field__icon">
                  <input
                    class="text-field__input"
                    type="date"
                    v-model="endDate"
                    @change="updateDatesFromInputs"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <!-- Чекбокс для бессрочных договоров -->
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="showOpenContracts"
                    v-model="showOpenContracts"
                    @change="logFilterChange"
                >
                <label class="form-check-label" for="showOpenContracts">
                  Показывать бессрочные договоры
                </label>
              </div>
            </div>
          </div>

          <div class="row">
            <div v-if="isLoading" class="col-12 top-24">
              Идёт загрузка...
            </div>

            <div
                v-else-if="!filteredContracts.length"
                class="col-12 top-24"
            >
              <div v-if="showOpenContracts">
                Договора за выбранную дату отсутствуют
              </div>
              <div v-else>
                Договора за выбранную дату отсутствуют.
                <br>
                <small>Попробуйте включить "Показывать бессрочные договоры"</small>
              </div>
            </div>
            <div v-else class="col-12">
              <ContractsList :contracts="filteredContracts" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractsList from "@/components/Ecology/Contracts/ContractsList.vue";
import moment from 'moment'

export default {
  name: 'ContractsView',
  components: { ContractsList },
  data() {
    const currentYear = moment().year();
    const startDate = `${currentYear}-01-01`;
    const endDate = `${currentYear}-12-31`;

    return {
      startDate: startDate,
      endDate: endDate,
      isLoading: true,
      showOpenContracts: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    Contracts() {
      return this.$store.state.eco_contracts || [];
    },
    filteredContracts() {
      console.log('=== ФИЛЬТРАЦИЯ ===');
      console.log('Параметры:', {
        startDate: this.startDate,
        endDate: this.endDate,
        showOpenContracts: this.showOpenContracts
      }
      );

      const startMoment = moment(this.startDate, 'YYYY-MM-DD');
      const endMoment = moment(this.endDate, 'YYYY-MM-DD');

      if (!startMoment.isValid() || !endMoment.isValid()) {
        console.log('Неверные даты фильтрации');
        return this.Contracts;
      }

      const filtered = this.Contracts.filter(contract => {
        if (!contract || !contract.ContractDateStart) {
          console.log('Пропускаем договор без даты начала:', contract?.ContractID);
          return false;
        }

        try {
          const contractStart = moment(contract.ContractDateStart);

          if (!contractStart.isValid()) {
            console.log('Пропускаем договор с невалидной датой начала:', contract?.ContractID);
            return false;
          }

          // Проверяем, является ли договор бессрочным
          const isOpenContract = contract.ContractDateFinish === '0001-01-01T00:00:00' ||
              contract.ContractDateFinish?.includes('0001-01-01');

          // Если договор бессрочный и чекбокс выключен - пропускаем
          if (isOpenContract && !this.showOpenContracts) {
            console.log(`Пропускаем бессрочный договор (чекбокс выключен): ${contract.ContractID}`);
            return false;
          }

          console.log(`Договор ${contract.ContractID}:`, {
            start: contractStart.format('DD.MM.YYYY'),
            end: contract.ContractDateFinish,
            isOpenContract: isOpenContract,
            startYear: contractStart.year()
          });

          // Если договор бессрочный
          if (isOpenContract) {
            // Для бессрочных договоров показываем только если:
            // 1. Договор начался в выбранном диапазоне ИЛИ
            // 2. Договор начался до выбранного диапазона (и еще действует)
            const startedInRange = contractStart.isBetween(startMoment, endMoment, 'day', '[]');
            const startedBeforeAndStillActive = contractStart.isSameOrBefore(endMoment, 'day');

            const result = startedInRange || startedBeforeAndStillActive;

            console.log(`  Бессрочный договор ${contract.ContractID}:`, {
              startedInRange,
              startedBeforeAndStillActive,
              result
            });

            return result;
          }

          // Для обычных договоров с датой окончания
          const contractEnd = moment(contract.ContractDateFinish);

          if (!contractEnd.isValid()) {
            console.log('Пропускаем договор с невалидной датой окончания:', contract?.ContractID);
            return false;
          }

          // Специальная логика для договоров, которые заканчиваются 01.01.2026
          // Такие договоры считаем закончившимися ДО начала дня 01.01.2026
          if (contractEnd.isSame(moment('2026-01-01'), 'day')) {
            // Для договоров, заканчивающихся 01.01.2026, проверяем:
            // 1. Договор начался в выбранном диапазоне И раньше его окончания
            // 2. Договор закончился в выбранном диапазоне (но не 01.01.2026 если это начало диапазона)
            const startedInRange = contractStart.isBetween(startMoment, endMoment, 'day', '[]');

            // Для окончания 01.01.2026: считаем, что договор закончился ДО этого дня
            // если startMoment - это тоже 01.01.2026
            let endedInRange = false;
            if (startMoment.isSame(moment('2026-01-01'), 'day')) {
              // Если диапазон начинается с 01.01.2026, то договор с окончанием в этот день не попадает
              endedInRange = false;
            } else {
              endedInRange = contractEnd.isBetween(startMoment, endMoment, 'day', '[]');
            }

            const activeDuringRange = contractStart.isSameOrBefore(startMoment, 'day') &&
                contractEnd.isAfter(startMoment, 'day'); // Используем isAfter вместо isSameOrAfter

            const result = startedInRange || endedInRange || activeDuringRange;

            console.log(`  Договор с окончанием 01.01.2026 ${contract.ContractID}:`, {
              startedInRange,
              endedInRange,
              activeDuringRange,
              result,
              specialNote: 'Договор считается закончившимся ДО 01.01.2026'
            });

            return result;
          }

          // Для обычных договоров с другой датой окончания
          // Договор считается подходящим если:
          // 1. Договор начался в выбранном диапазоне ИЛИ
          // 2. Договор закончился в выбранном диапазоне ИЛИ
          // 3. Договор действовал в течение всего выбранного диапазона
          const startedInRange = contractStart.isBetween(startMoment, endMoment, 'day', '[]');
          const endedInRange = contractEnd.isBetween(startMoment, endMoment, 'day', '[]');
          const activeDuringRange = contractStart.isSameOrBefore(startMoment, 'day') &&
              contractEnd.isSameOrAfter(endMoment, 'day');

          const result = startedInRange || endedInRange || activeDuringRange;

          console.log(`  Обычный договор ${contract.ContractID}:`, {
            startedInRange,
            endedInRange,
            activeDuringRange,
            result
          });

          return result;

        } catch (error) {
          console.error('Ошибка при фильтрации договора:', error, contract);
          return false;
        }
      });

      console.log('=== РЕЗУЛЬТАТ ФИЛЬТРАЦИИ ===');
      console.log('Всего договоров:', this.Contracts.length);
      console.log('Отфильтровано:', filtered.length);

      // Детальная информация о договорах с окончанием 01.01.2026
      const jan1_2026_Contracts = this.Contracts.filter(c => {
        if (!c.ContractDateFinish) return false;
        const end = moment(c.ContractDateFinish);
        return end.isValid() && end.isSame(moment('2026-01-01'), 'day');
      });

      const jan1_2026_Filtered = filtered.filter(c => {
        if (!c.ContractDateFinish) return false;
        const end = moment(c.ContractDateFinish);
        return end.isValid() && end.isSame(moment('2026-01-01'), 'day');
      });

      console.log('Договоры с окончанием 01.01.2026:', {
        'Всего таких договоров': jan1_2026_Contracts.length,
        'Показано после фильтрации': jan1_2026_Filtered.length,
        'Список показанных': jan1_2026_Filtered.map(c => ({
          ID: c.ContractID,
          Начало: moment(c.ContractDateStart).format('DD.MM.YYYY'),
          Окончание: moment(c.ContractDateFinish).format('DD.MM.YYYY')
        }))
      });

      // Группируем договоры по типам для отладки
      const byType = filtered.reduce((acc, contract) => {
        const isOpen = contract.ContractDateFinish === '0001-01-01T00:00:00' ||
            contract.ContractDateFinish?.includes('0001-01-01');
        const isJan1_2026 = contract.ContractDateFinish &&
            moment(contract.ContractDateFinish).isSame(moment('2026-01-01'), 'day');

        let type = 'Обычные';
        if (isOpen) type = 'Бессрочные';
        else if (isJan1_2026) type = 'С окончанием 01.01.2026';

        if (!acc[type]) acc[type] = [];
        acc[type].push({
          ID: contract.ContractID,
          Название: contract.ContractName,
          Начало: moment(contract.ContractDateStart).format('DD.MM.YYYY'),
          Окончание: isOpen ? 'бессрочный' : moment(contract.ContractDateFinish).format('DD.MM.YYYY')
        });
        return acc;
      }, {});

      console.log('Отфильтрованные договоры по типам:', byType);

      return filtered;
    }
  },
  created() {
    this.$store
        .dispatch("fetchEcologyContracts")
        .then(() => {
          console.log('Договоры загружены. Всего:', this.Contracts.length);
        })
        .catch((error) => {
          console.error('Ошибка при загрузке договоров:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
  },
  methods: {
    format_date(value, time = 'date') {
      if (!value) return '';

      try {
        if (time === 'date') {
          return moment(value).format('DD.MM.YYYY');
        } else {
          return moment(value).format('DD.MM.YYYY HH:mm');
        }
      } catch (error) {
        console.error('Ошибка форматирования даты:', error, value);
        return '';
      }
    },

    updateDatesFromInputs() {
      console.log('Обновление дат:', { startDate: this.startDate, endDate: this.endDate });

      // Даты уже в правильном формате из v-model
      if (moment(this.startDate, 'YYYY-MM-DD').isValid() && moment(this.endDate, 'YYYY-MM-DD').isValid()) {
        console.log('Даты валидны');
      } else {
        console.log('Получены невалидные даты');
      }
    },

    logFilterChange() {
      console.log('Чекбокс "Показывать бессрочные договоры" изменен:', this.showOpenContracts);
    }
  }
};
</script>

<style scoped>
.top-24 {
  margin-top: 24px;
}

.card {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-check {
  margin-left: 20px;
  padding-top: 8px;
}

.form-check-input {
  margin-right: 8px;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

@media (max-width: 768px) {
  .col-md-6 {
    margin-bottom: 15px;
  }

  .form-check {
    margin-left: 0;
  }
}
</style>